import React, { useState } from 'react';
import './ReceiptPage.css';
import axios from 'axios';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMicrophone } from '@fortawesome/free-solid-svg-icons';

function ReceiptPage() {
  const [amount, setAmount] = useState('');
  const [description, setDescription] = useState('');
  const [date, setDate] = useState('');
  const [image, setImage] = useState(null);
  const [project, setProject] = useState('');

  const handleVoiceInput = () => {
    const recognition = new window.webkitSpeechRecognition();
    recognition.lang = 'en-US';
    recognition.interimResults = false;
    recognition.maxAlternatives = 1;

    recognition.start();

    recognition.onresult = (event) => {
      const speechResult = event.results[0][0].transcript;
      setDescription(speechResult);
    };

    recognition.onerror = (event) => {
      console.error('Speech recognition error', event.error);
    };
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (image) {
      const formData = new FormData();
      formData.append('myfile', image);
      //formData.append('upload_preset', 'YOUR_UPLOAD_PRESET'); // Replace with your upload preset
      //formData.append('folder', 'YOUR_FOLDER_NAME'); // Replace with your folder name

      try {
        const response = await axios.post(process.env.REACT_APP_GOOGLE_DRIVE_UPLOAD_URL + '?parent=root', formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
          }
        });
        console.log('File uploaded successfully:', response.data);
        // Handle the rest of the receipt submission logic here
      } catch (error) {
        console.error('File upload failed:', error);
      }
    }
  };

  return (
    <div className="receipt-page">
      <h2>Submit Receipt</h2>
      <form onSubmit={handleSubmit}>
        <div>
          <label>Project:</label>
          <select
            value={project}
            onChange={(e) => setProject(e.target.value)}
            required
            style={{
              padding: '8px',
              borderRadius: '4px',
              border: '1px solid #ccc',
              width: '100%',
              boxSizing: 'border-box'
            }}
          >
            <option value="">Select a project</option>
            <option value="project1">Project 1</option>
            <option value="project2">Project 2</option>
            <option value="project3">Project 3</option>
          </select>
        </div>
        <div>
          <label>Amount:</label>
          <input
            type="number"
            value={amount}
            onChange={(e) => setAmount(e.target.value)}
            required
          />
        </div>
        <div>
          <label>Description:</label>
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <input
              type="text"
              value={description}
              onChange={(e) => setDescription(e.target.value)}
              required
            />
            <button type="button" onClick={handleVoiceInput} style={{ marginLeft: '8px', padding: '5px' }}>
              <FontAwesomeIcon icon={faMicrophone} />
            </button>
          </div>
        </div>
        <div>
          <label>Date:</label>
          <input
            type="date"
            value={date}
            onChange={(e) => setDate(e.target.value)}
            required
          />
        </div>
        <div>
          <label>Receipt Image:</label>
          <input
            type="file"
            onChange={(e) => setImage(e.target.files[0])}
            required
          />
        </div>
        <button type="submit">Submit</button>
      </form>
    </div>
  );
}

export default ReceiptPage;